export const claimsQueryKeys = {
  all: ['claims'] as const,
  campaigns: () => [...claimsQueryKeys.all, 'campaigns'] as const,
};
